import { render } from "./ComisionesList.vue?vue&type=template&id=fdd16a2c&scoped=true"
import script from "./ComisionesList.vue?vue&type=script&lang=js"
export * from "./ComisionesList.vue?vue&type=script&lang=js"

import "./ComisionesList.vue?vue&type=style&index=0&id=fdd16a2c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd16a2c"]])

export default __exports__